import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App as AntApp, ConfigProvider } from 'antd';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { PermissionsProvider } from './context/PermissionsContext';
import { initTelemetry } from './services/telemetry';
import './styles/main.css';

// Telemetry is a no-op unless the pipeline injected an instrumentation
// key at build time (see services/telemetry.js).
initTelemetry();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#004638',
            colorPrimaryHover: '#0a5c4a',
            colorPrimaryActive: '#00392e',
            colorLink: '#004638',
            colorLinkHover: '#0a5c4a',
            colorBgLayout: '#f4f7fb',
            colorBgContainer: '#ffffff',
            colorTextBase: '#1f2937',
            borderRadius: 8,
          },
          components: {
            Layout: {
              headerBg: '#ffffff',
              siderBg: '#f5f6f7',
            },
            Menu: {
              itemBg: '#f5f6f7',
              itemHoverBg: '#e6f1ee',
              itemSelectedBg: '#e6f1ee',
              itemSelectedColor: '#004638',
            },
          },
        }}
      >
        <AntApp>
          <AuthProvider>
            <PermissionsProvider>
              <App />
            </PermissionsProvider>
          </AuthProvider>
        </AntApp>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
